/*
 * @Author: Nanxing Xiang
 * @Date: 2021-01-11 10:11:07
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-06-15 16:47:42
 * @Description: file content
 */
import { getAppUserAgentInfo } from '@saturn/ua-parser';
import configDev from './config.dev';
import configOnline from './config.online';
import configQa from './config.qa';
import { DefaultConfig } from './types';

const getYiPinLive = () => {
  const ua = getAppUserAgentInfo();
  if (
    ua &&
    ua.version.major >= 6 &&
    ua.version.minor >= 2 &&
    ua.version.patch >= 1
  ) {
    return '寻觅';
  }
  return '音九';
};

const defaultConfig: DefaultConfig = {
  appnames: {
    yizhibo: '音九',
    ellite: '音九',
    yipinlive: getYiPinLive(),
    magiclive: '哇塞直播',
    sizhibo: '丝直播',
    sizulive: '丝足直播',
    zujilive: '音九',
    easylove: '易恋',
    footlive: '茗莲',
    onelive: '音九',
    rhlive: '右手',
    eplive: '右手',
    zcamera: '时光记录仪',
    hola: '初见',
    miy: '蜜Y'
  }
};

const getConifg = () => {
  if (process.env.REACT_APP_ENV === 'qa')
    return { ...defaultConfig, ...configQa };
  if (process.env.REACT_APP_ENV === 'prod')
    return { ...defaultConfig, ...configOnline };
  return { ...defaultConfig, ...configDev };
};
const config = getConifg();
export default config;
